import { toast } from "react-toastify";

export const withToast = async (
  request,
  { catchError = false, onSuccess = null } = {}
) => {
  try {
    return await request().then((response) => {
      if (onSuccess) {
        toast.success(onSuccess, {
          theme: "colored",
        });
      }
      return response;
    });
  } catch (error) {
    if (error.response?.status === 404) {
      toast.warning(error.response?.data?.message ?? error.message, {
        theme: "colored",
      });
    } else {
      toast.error(error.response?.data?.message ?? error.message, {
        theme: "colored",
      });
    }
    if (!catchError) throw error;
  }
};
